import { useState, useEffect, RefObject } from "react";

const PIXEL_THRESHOLD = 2;
export const useScrolledToBottom = (
  elementRef: RefObject<HTMLElement | null>,
) => {
  const [scrolledToBottom, setScrolledToBottom] = useState(true);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const scrolled = () => {
      if (
        element.scrollTop + element.clientHeight >=
        element.scrollHeight - PIXEL_THRESHOLD
      ) {
        if (!scrolledToBottom) setScrolledToBottom(true);
      } else {
        if (scrolledToBottom) setScrolledToBottom(false);
      }
    };

    scrolled();

    element.addEventListener("scroll", scrolled);

    const resizeObserver = new ResizeObserver(() => {
      scrolled();
    });

    for (const child of element.children) {
      resizeObserver.observe(child);
    }

    return () => {
      element.removeEventListener("scroll", scrolled);
      resizeObserver.disconnect();
    };
  }, [elementRef, scrolledToBottom]);

  return scrolledToBottom;
};
